import { makePersistable as _makePersistable } from 'mobx-persist-store'
import AsyncStorage from '@react-native-async-storage/async-storage'

export const makePersistable = <T extends Object>(
  obj: T,
  properties: (keyof T)[],
) => {
  return _makePersistable(obj, {
    name: obj.constructor.name,
    properties,
    storage: AsyncStorage,
  })
}
